// Components
import CurrentlyReading from "../react_components/currently_reading/currently_reading";
import Newsfeed from "../react_components/newsfeed/newsfeed";
import ShelfDisplay from "../react_components/shelf_display";
import UserShelvesBookCounts from "../react_components/user_shelves_book_counts";
import ReadingChallenge from "../react_components/reading_challenge";
import RecommendationsWidget from "../react_components/home_page/recommendations_widget";
import ImproveRecommendations from "../react_components/home_page/improve_recommendations";
import Footer from "../react_components/home_page/footer";
import GoogleBannerAd from "../react_components/ads/google_banner_ad";
import EditorialBlogThumbnail from
  "../react_components/home_page/editorial_blog_thumbnail";
import ChoiceWidget from "../react_components/home_page/choice_widget";
import SponsoredBook from "../react_components/ads/custom_campaign/sponsored_book";
import YoutubeVideo from "../react_components/ads/custom_campaign/youtube_video";
import Carousel from "../react_components/carousel/carousel";

// Stores
import NewsfeedUpdateStore from "../react_stores/newsfeed_update_store";
import AuthorFollowStore from "../react_stores/author_follow_store";
import RecommendationsStore from "../react_stores/recommendations_store";
import CommentsStore from "../react_stores/comments_store";
import LikeStore from "../react_stores/like_store";
import ShelvingsStore from "../react_stores/shelvings_store";
import UserShelvesStore from "../react_stores/user_shelves_store";
import ReadingSessionStore from "../react_stores/reading_session_store";
import GoogleAdsStore from "../react_stores/google_ads_store";
import ReadingChallengeStore from "../react_stores/reading_challenge_store";
import UserRatingsStore from "../react_stores/user_ratings_store";
import ClickTrackingStore from "../react_stores/click_tracking_store";
import CarouselStore from "../react_stores/carousel_store";
import UserNotInterestedStore from "../react_stores/user_not_interested_store";

export const HomeComponents = {
  CurrentlyReading,
  Newsfeed,
  GoogleBannerAd,
  ReadingChallenge,
  RecommendationsWidget,
  ImproveRecommendations,
  ShelfDisplay,
  UserShelvesBookCounts,
  Footer,
  EditorialBlogThumbnail,
  SponsoredBook,
  YoutubeVideo,
  Carousel,
  ChoiceWidget,
};

export const HomeStores = {
  NewsfeedUpdateStore,
  AuthorFollowStore,
  RecommendationsStore,
  CommentsStore,
  GoogleAdsStore,
  LikeStore,
  ShelvingsStore,
  UserShelvesStore,
  ReadingSessionStore,
  ReadingChallengeStore,
  UserRatingsStore,
  ClickTrackingStore,
  CarouselStore,
  UserNotInterestedStore,
};
